export const sdkLoadTime = Date.now();

const ua = window.navigator.userAgent;
// 快手小程序
export const isKwaiMp = /miniProgram(.*)(KUAISHOU|NEBULA)/gi.test(ua);

const isWeiBo = /Weibo/gi.test(ua);

// 快手 App
export const isKuaiShouApp = / (Kwai|Kwai_Lite|Kwai_Pro|livemate|kswv)\//i.test(ua);

function getOS(userAgent: string) {
  if (/Windows NT (\d+\.\d+)/.test(userAgent)) {
    return `Windows ${RegExp.$1}`;
  } else if (/Mac OS X (\d+[._]\d+)/.test(userAgent)) {
    return `Mac OS X ${RegExp.$1.replace('_', '.')}`;
  } else if (/iPhone OS (\d+[._]\d+)/.test(userAgent)) {
    return `iOS ${RegExp.$1.replace('_', '.')}`;
  } else if (/Android (\d+)/.test(userAgent)) {
    return `Android ${RegExp.$1}`;
  } else if (/Linux/.test(userAgent)) {
    return 'Linux';
  }
  return 'Unknown';
}

// function getOSVersion(userAgent: string) {
//   let os = 'Unknown';
//   let version = 'Unknown';

//   if (userAgent.indexOf('Windows NT 10.0') !== -1) {
//     os = 'Windows';
//     version = '10';
//   } else if (userAgent.indexOf('Windows NT 6.3') !== -1) {
//     os = 'Windows';
//     version = '8.1';
//   } else if (userAgent.indexOf('Windows NT 6.2') !== -1) {
//     os = 'Windows';
//     version = '8';
//   } else if (userAgent.indexOf('Windows NT 6.1') !== -1) {
//     os = 'Windows';
//     version = '7';
//   } else if (userAgent.indexOf('like Mac') !== -1) {
//     os = 'iOS';
//     const iosVersion = userAgent.match(/OS (\d+[._]\d+)/);
//     if (iosVersion) {
//       version = iosVersion[1].replace(/_/g, '.');
//     }
//   } else if (userAgent.indexOf('Mac OS X') !== -1) {
//     os = 'Mac OS';
//     const macVersion = userAgent.match(/Mac OS X (\d+[._]\d+)/);
//     if (macVersion) {
//       version = macVersion[1].replace(/_/g, '.');
//     }
//   } else if (userAgent.indexOf('Android') !== -1) {
//     os = 'Android';
//     const androidVersion = userAgent.match(/Android (\d+[.\d]*)/);
//     if (androidVersion) {
//       version = androidVersion[1];
//     }
//   } else if (userAgent.indexOf('Linux') !== -1) {
//     os = 'Linux';
//     version = ''; // Linux 版本识别较复杂，通常不在 UA 中
//   }

//   return `${os} ${version}`;
// }

function getBrowser(userAgent: string) {
  if (/Kim\/\s?((?:\d+[.-]?)+)\s/.test(userAgent)) {
    return `Kim ${RegExp.$1}`;
  } else if (/Edge\/(\d+\.\d+)/.test(userAgent)) {
    return `Edge ${RegExp.$1}`;
  } else if (/Chrome\/(\d+\.\d+)/.test(userAgent)) {
    return `Chrome ${RegExp.$1}`;
  } else if (/Firefox\/(\d+\.\d+)/.test(userAgent)) {
    return `Firefox ${RegExp.$1}`;
  } else if (/Safari\/(\d+\.\d+)/.test(userAgent) && !/Chrome/.test(userAgent)) {
    return `Safari ${RegExp.$1}`;
  } else if (/MSIE (\d+\.\d+)/.test(userAgent) || /Trident.*rv:(\d+\.\d+)/.test(userAgent)) {
    return `Internet Explorer ${RegExp.$1}`;
  } else if (/MicroMessenger\/(\d+\.\d+)/.test(userAgent)) {
    return `WeChat ${RegExp.$1}`;
  }
  return 'Unknown';
}

function getUAInfo(ua: string) {
  try {
    const ua_os = getOS(ua);
    const ua_browser = getBrowser(ua);
    return {
      ua_os,
      ua_browser
    };
  } catch (e) {
    console.error('logger.getUAInfo报错：', e);
    return {
      ua_os: 'error',
      ua_browser: 'error'
    };
  }
}

export const getDevice = (function () {
  let cacheDevice: ReturnType<typeof getDevice_>;

  function getDevice_() {
    const isIOS = ua.match(/(iPhone|iPod|iPad).*OS\s([\d_]+)/);

    const isAndroid = ua.match(/(Android);?[\s/]+([\d.]+)?/);

    // 微信小程序 mac pc 版本
    const isWxMpMac = /MiniProgramEnv\/Mac/gi.test(ua);

    const isMobile = isIOS || isAndroid || isWxMpMac;

    // 微信环境
    const isWechat = /MicroMessenger/i.test(ua);

    const lowUa = ua.toLowerCase();
    // 微信小程序
    const isWxMp = window['__wxjs_environment']
      ? window['__wxjs_environment'] === 'miniprogram'
      : /miniProgram/i.test(lowUa);

    const device = {
      isIos: 0,
      isAndroid: 0,
      isPc: 0,
      // isSafari: lowUa.indexOf('safari') >= 0 && lowUa.indexOf('chrome') < 0,
      // ua,
      isMobile: isMobile ? 1 : 0,
      isKim: ua.indexOf('Kim/') >= 0 ? 1 : 0,
      isMac: /macintosh|mac os x/i.test(ua) ? 1 : 0,
      //微信小程序
      is_wx_applet: isWxMp && isWechat ? 1 : 0,
      //桌面端微信小程序
      isWx_mini: isWxMp && !isWechat ? 1 : 0,
      //微信h5
      isWx_h5: !isWxMp && isWechat ? 1 : 0,
      isWin: navigator.platform == 'Win32' || navigator.platform == 'Windows' ? 1 : 0,
      isIPad: /ipad/gi.test(ua),
      isKwaiMp,
      isKuaiShouApp,
      ...getUAInfo(ua)
    };

    if (isAndroid) {
      device.isAndroid = 1;
      // device.version = _android[2];
      return device;
    }

    if (isIOS) {
      device.isIos = 1;
      // device.version = _ios[2].replace(/_/g, '.');
      return device;
    }

    device.isPc = 1;
    return device;
  }
  return function () {
    return cacheDevice || (cacheDevice = getDevice_());
  };
})();

export function getFormatDate(date: Date = new Date()) {
  const yyyy = `${date.getFullYear()}`;
  const mm = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1; // getMonth() is zero-based
  const dd = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const hh = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const min = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const ss = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
  return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
}

export function getUUid() {
  return Math.random().toString(36).slice(2);
}

export function parseQuery(queryString: string) {
  return queryString
    .replace('?', '')
    .split('&')
    .reduce((cur, item) => {
      const tmp = item.split('=');
      cur[tmp[0]] = tmp[1];
      return cur;
    }, {});
}

// 优先使用pagehide 其次使用beforeunload;
const unLoadEventName = 'onpagehide' in window ? 'pagehide' : 'beforeunload';

//注册页面关闭回调
export function addOnUnloadCallback(callback: () => void) {
  window.addEventListener(unLoadEventName, callback);
}

export const domContentLoadedPromise = new Promise(resolve => {
  document.addEventListener('DOMContentLoaded', resolve);
});

export async function loadScript(url: string, attribures?: { [key: string]: string }) {
  await domContentLoadedPromise;
  return new Promise<void>(resolve => {
    const scriptElem: HTMLScriptElement = document.createElement('script');
    scriptElem.charset = 'utf-8';
    if (attribures) {
      Object.keys(attribures).forEach(key => {
        scriptElem.setAttribute(key, attribures[key]);
      });
    }
    // IE
    if ((scriptElem as any).readyState) {
      (scriptElem as any).onreadystatechange = function () {
        if (
          (scriptElem as any).readyState === 'loaded' ||
          (scriptElem as any).readyState === 'complete'
        ) {
          (scriptElem as any).onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // 其他浏览器
      scriptElem.onload = function () {
        resolve();
      };
    }
    scriptElem.src = url;
    document.body.appendChild(scriptElem);
  });
}

//是否截图模式
export const IS_SNAPSHOT = location.search.indexOf('snapshot=true') >= 0;

// https://docs.corp.kuaishou.com/d/home/fcAAv4bDdSVVWvKG3dL1hLZGZ# by 李丹
// 更新：https://docs.corp.kuaishou.com/d/home/fcAB-n9luSXpCsGewzeF63zCa by 德彪
// source_app:
// ● other : 其它
// ● web : 电脑端网页
// ● H5 : 移动端网页
// ● KIM : KIM内置
export function getSourceApp() {
  const device = getDevice();
  if (isWeiBo) {
    return 'weibo';
  }

  // 快手小程序
  if (isKwaiMp) {
    return 'kwai_applet';
  }

  // 快手H5
  if (isKuaiShouApp) {
    return 'kwai_H5';
  }

  // 微信小程序
  if (device.is_wx_applet) {
    return 'wechat_applet';
  }

  // 微信小程序（桌面端）
  if (device.isWx_mini) {
    return 'wechat_mini';
  }

  // 微信H5
  if (device.isWx_h5) {
    return 'wechat_H5';
  }

  if (device.isKim) {
    // web端KIM内置版
    if (device.isPc) {
      return 'kim_web';
    } else {
      // KIM内置版H5
      return 'kim_H5';
    }
  }

  // 其他移动端浏览器网页
  if (device.isMobile) {
    return 'H5';
  }

  // 其他电脑端网页
  if (device.isPc) {
    return 'web';
  }

  return 'other';
}

// https://docs.corp.kuaishou.com/d/home/fcAAv4bDdSVVWvKG3dL1hLZGZ# by 李丹
// platform:
// ● other : 其它
// ● iPad : iPad
// ● iOS : iOS系统
// ● Android : Android系统
// ● Mac : Mac系统
// ● Win : Windows系统
export function getPlatform() {
  const device = getDevice();
  if (device.isIPad) {
    return 'iPad';
  }
  if (device.isIos) {
    return 'iphone'; // by 齐伟玲 ：“辛苦把ios改成“iphone”吧，这样比较好和iPad区分开”
  }
  // 必须在isIos之后，isIos必定isMac
  if (device.isMac) {
    return 'Mac';
  }
  if (device.isAndroid) {
    return 'Android';
  }
  if (device.isWin) {
    return 'Win';
  }
  return 'other';
}

export function getCookie(name: string) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  return arr ? unescape(arr[2]) : '';
}

export function getNavigatorLang() {
  const navigator = window.navigator as (Navigator & { userLanguage: string }) | null;

  return navigator?.language || navigator?.userLanguage || '';
}

export const isWiki = /^\/(?:(?:[tkb]\/home)|(?:wiki\/[sd]))\//.test(location.pathname);

// 加载时，在控制台打印出必要信息

const colorStart = 'padding: 1px; border-radius: 3px 0 0 3px; color: #fff; background: #606060;';
const colorString = 'padding: 1px; border-radius: 0 3px 3px 0; color: #fff; background: #1475b2;'; // 蓝色

export function consoleLog(key: string, value: string | number) {
  const str = `%c ${key} %c ${value} `;
  try {
    console.log(str, colorStart, colorString);
  } catch (e) {}
}

export function isCdnAssets(url: string) {
  if (
    url &&
    typeof url === 'string' &&
    (url.indexOf('docs-h2.corp.kuaishou.com/assets') >= 0 || // 静态资源本地版本
      url.indexOf('-11880.ap4r.com/kos/') >= 0 || // 海外CDN
      url.indexOf('static.yximgs.com/udata/pkg') >= 0)
  ) {
    return true;
  }
  return false;
}

/**
 * 以指定长度截取字符串作为摘要，保留最后一个单词不被截断
 * @param source
 * @param length
 * @returns
 */
export function getDigest(source: string, length: number) {
  if (source && source.length) {
    if (source.length > length) {
      const endIndex = source.indexOf(' ', length);
      const sliceIndex = endIndex >= 0 ? endIndex : length;
      return `${source.slice(0, sliceIndex)}+${source.length - sliceIndex}`;
    } else {
      return source;
    }
  }
  return '';
}

export function safeJsonStringify(data: any) {
  try {
    return JSON.stringify(data);
  } catch (e) {
    console.error('logger.safeJsonStringify报错：', e);
    try {
      const getCircularReplacer = () => {
        const seen = new WeakSet();
        return (key: string, value: any) => {
          if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
              return `${key}-CIRCLE`;
            }
            seen.add(value);
          }
          return value;
        };
      };

      return JSON.stringify(data, getCircularReplacer());
    } catch (e) {
      console.error('logger.safeJsonStringify报错：', e);
      return '';
    }
  }
}
